import { handleActions } from 'redux-actions';
import types from './types';
import { mergeIn } from '../../helpers/state.helper';

const initialState = {
  langs: [],
  defaultLanguage: 'en',
  requestError: '',
  pageTitle: '',
  enableCoverColor: 1,
  subscriber: null,
  hasLoadedPage: false,
  socialAuth: [],
  customColors: {},
  customCss: '',
  defaultRoute: '/dashboard',
  show2faPages: false,
};

const reducer = handleActions(
  {
    [types.UPDATE_SETTINGS]: mergeIn(action => action.payload),
    [types.SET_SOCIAL_AUTH]: mergeIn(action => ({ socialAuth: action.payload })),
  },
  initialState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/settings/reducers.js